import React from 'react';


function Contact() {
    return (
        <div className='sectionPage'>
            <p>For all enquiries contact us at <a href="mailto:info@wtsdu.com">info@wtsdu.com</a></p>
        </div>
    );
}

export default Contact;